import { ref, computed, watch } from "vue";

function getInitialTheme() {
  const stored = localStorage.getItem("theme");
  if (stored === "dark" || stored === "light") return stored;
  if (window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
  return "light";
}

function applyTheme(theme) {
  if (theme === "dark") {
    document.documentElement.classList.add("dark");
  } else {
    document.documentElement.classList.remove("dark");
  }
}

const currentTheme = ref(getInitialTheme());
applyTheme(currentTheme.value);

watch(currentTheme, (val) => {
  applyTheme(val);
  localStorage.setItem("theme", val);
});

export function useTheme() {
  const isDark = computed(() => currentTheme.value === "dark");

  function toggleTheme() {
    currentTheme.value = currentTheme.value === "dark" ? "light" : "dark";
  }

  function setTheme(theme) {
    currentTheme.value = theme;
  }

  return { currentTheme, isDark, toggleTheme, setTheme };
}
